export var TicketsStatsBreakdown;
(function (TicketsStatsBreakdown) {
    TicketsStatsBreakdown[TicketsStatsBreakdown["ALL"] = 0] = "ALL";
    TicketsStatsBreakdown[TicketsStatsBreakdown["LOCALE"] = 10] = "LOCALE";
    TicketsStatsBreakdown[TicketsStatsBreakdown["CHANNEL"] = 20] = "CHANNEL";
    TicketsStatsBreakdown[TicketsStatsBreakdown["COUNTRY"] = 30] = "COUNTRY";
    TicketsStatsBreakdown[TicketsStatsBreakdown["LABEL"] = 40] = "LABEL";
})(TicketsStatsBreakdown || (TicketsStatsBreakdown = {}));
;
export var TicketsAgentPerformanceSortType;
(function (TicketsAgentPerformanceSortType) {
    TicketsAgentPerformanceSortType[TicketsAgentPerformanceSortType["NUMBER_OF_REPLIES"] = 1] = "NUMBER_OF_REPLIES";
    TicketsAgentPerformanceSortType[TicketsAgentPerformanceSortType["SOLVED_TICKETS"] = 2] = "SOLVED_TICKETS";
    TicketsAgentPerformanceSortType[TicketsAgentPerformanceSortType["SATISFACTION_RATE"] = 3] = "SATISFACTION_RATE";
})(TicketsAgentPerformanceSortType || (TicketsAgentPerformanceSortType = {}));
;
export var TicketsGroupPerformanceSortType;
(function (TicketsGroupPerformanceSortType) {
    TicketsGroupPerformanceSortType[TicketsGroupPerformanceSortType["NUMBER_OF_REPLIES"] = 1] = "NUMBER_OF_REPLIES";
    TicketsGroupPerformanceSortType[TicketsGroupPerformanceSortType["SOLVED_TICKETS"] = 2] = "SOLVED_TICKETS";
    TicketsGroupPerformanceSortType[TicketsGroupPerformanceSortType["SATISFACTION_RATE"] = 3] = "SATISFACTION_RATE";
    TicketsGroupPerformanceSortType[TicketsGroupPerformanceSortType["RESPONSE_TIME"] = 4] = "RESPONSE_TIME";
})(TicketsGroupPerformanceSortType || (TicketsGroupPerformanceSortType = {}));
;
export var AggType;
(function (AggType) {
    AggType[AggType["UNIQUE_VISITORS"] = 0] = "UNIQUE_VISITORS";
    AggType[AggType["CONTACTED_SUPPORT"] = 1] = "CONTACTED_SUPPORT";
    AggType[AggType["SELF_HELP_SUCCESS"] = 2] = "SELF_HELP_SUCCESS";
    //Searches
    AggType[AggType["SEARCHES"] = 10] = "SEARCHES";
    AggType[AggType["POPULAR_SEARCHES"] = 11] = "POPULAR_SEARCHES";
    AggType[AggType["UN_EFFECTIVE_SEARCH_TERMS"] = 12] = "UN_EFFECTIVE_SEARCH_TERMS";
    AggType[AggType["EFFECTIVE_SEARCH_TERMS"] = 13] = "EFFECTIVE_SEARCH_TERMS";
    AggType[AggType["UN_ANSWERED_SEARCH_TERMS"] = 14] = "UN_ANSWERED_SEARCH_TERMS";
    AggType[AggType["SEARCH_TERM_CLICKED_ARTICLES"] = 15] = "SEARCH_TERM_CLICKED_ARTICLES";
    AggType[AggType["AVERAGE_POSITION"] = 16] = "AVERAGE_POSITION";
    //Articles
    AggType[AggType["ARTICLES_PAGE_VIEW"] = 20] = "ARTICLES_PAGE_VIEW";
    AggType[AggType["MOST_READ_ARTICLES"] = 21] = "MOST_READ_ARTICLES";
    AggType[AggType["MOST_VOTED_FEATURE_REQUESTS"] = 22] = "MOST_VOTED_FEATURE_REQUESTS";
    AggType[AggType["MOST_EXPERIENCED_KNOWN_ISSUES"] = 23] = "MOST_EXPERIENCED_KNOWN_ISSUES";
    AggType[AggType["MOST_UNHELPFULL_ARTICLES"] = 24] = "MOST_UNHELPFULL_ARTICLES";
    AggType[AggType["MOST_HELPFULL_ARTICLES"] = 25] = "MOST_HELPFULL_ARTICLES";
    AggType[AggType["ARTICLES_FIRST_PUBLISH"] = 26] = "ARTICLES_FIRST_PUBLISH";
    AggType[AggType["ARTICLES_UPDATED"] = 27] = "ARTICLES_UPDATED";
    AggType[AggType["ACTIVE_AUTHORS"] = 28] = "ACTIVE_AUTHORS";
    //Tickets
    AggType[AggType["TOP_ISSUES"] = 30] = "TOP_ISSUES";
    AggType[AggType["NUMBER_OF_REPLIES"] = 35] = "NUMBER_OF_REPLIES";
    AggType[AggType["REPLIES_SATISFACTION_RATE"] = 50] = "REPLIES_SATISFACTION_RATE";
    AggType[AggType["SATISFACTION_SCORE"] = 80] = "SATISFACTION_SCORE";
    // Actually used
    AggType[AggType["OPEN_TICKETS"] = 40] = "OPEN_TICKETS";
    AggType[AggType["SOLVED_TICKETS"] = 41] = "SOLVED_TICKETS";
    AggType[AggType["CLOSED_TICKETS"] = 42] = "CLOSED_TICKETS";
    AggType[AggType["REOPEN_TICKETS"] = 43] = "REOPEN_TICKETS";
    AggType[AggType["CLOSED_BY_MERGE"] = 44] = "CLOSED_BY_MERGE";
    AggType[AggType["AVERAGE_RESPONSE_TIME"] = 51] = "AVERAGE_RESPONSE_TIME";
    //Tasks
    AggType[AggType["TASKS_CREATED"] = 60] = "TASKS_CREATED";
    AggType[AggType["TASKS_COMPLETED"] = 61] = "TASKS_COMPLETED";
    //GENERAL
    AggType[AggType["LAST_CONTRIBUTED"] = 70] = "LAST_CONTRIBUTED";
})(AggType || (AggType = {}));
;
export var TicketsOverviewTabType;
(function (TicketsOverviewTabType) {
    TicketsOverviewTabType[TicketsOverviewTabType["NEW_TICKETS"] = 40] = "NEW_TICKETS";
    TicketsOverviewTabType[TicketsOverviewTabType["REOPEN_TICKETS"] = 43] = "REOPEN_TICKETS";
    TicketsOverviewTabType[TicketsOverviewTabType["SOLVED_TICKETS"] = 41] = "SOLVED_TICKETS";
    TicketsOverviewTabType[TicketsOverviewTabType["CLOSED_TICKETS"] = 42] = "CLOSED_TICKETS";
    TicketsOverviewTabType[TicketsOverviewTabType["CLOSED_BY_MERGE"] = 44] = "CLOSED_BY_MERGE";
    TicketsOverviewTabType[TicketsOverviewTabType["NUMBER_OF_REPLIES"] = 35] = "NUMBER_OF_REPLIES";
    TicketsOverviewTabType[TicketsOverviewTabType["RESPONSE_TIME"] = 51] = "RESPONSE_TIME";
    TicketsOverviewTabType[TicketsOverviewTabType["SATISFACTION_SCORE"] = 80] = "SATISFACTION_SCORE";
})(TicketsOverviewTabType || (TicketsOverviewTabType = {}));
;
export var TicketsAgentPerformanceType;
(function (TicketsAgentPerformanceType) {
    TicketsAgentPerformanceType[TicketsAgentPerformanceType["SOLVED_TICKETS"] = 41] = "SOLVED_TICKETS";
    TicketsAgentPerformanceType[TicketsAgentPerformanceType["NUMBER_OF_REPLIES"] = 35] = "NUMBER_OF_REPLIES";
})(TicketsAgentPerformanceType || (TicketsAgentPerformanceType = {}));
;
export var TicketsGroupPerformanceType;
(function (TicketsGroupPerformanceType) {
    TicketsGroupPerformanceType[TicketsGroupPerformanceType["NUMBER_OF_REPLIES"] = 35] = "NUMBER_OF_REPLIES";
    TicketsGroupPerformanceType[TicketsGroupPerformanceType["SOLVED_TICKETS"] = 41] = "SOLVED_TICKETS";
    TicketsGroupPerformanceType[TicketsGroupPerformanceType["SATISFACTION_RATE"] = 50] = "SATISFACTION_RATE";
    TicketsGroupPerformanceType[TicketsGroupPerformanceType["RESPONSE_TIME"] = 51] = "RESPONSE_TIME";
    TicketsGroupPerformanceType[TicketsGroupPerformanceType["SATISFACTION_SCORE"] = 80] = "SATISFACTION_SCORE";
})(TicketsGroupPerformanceType || (TicketsGroupPerformanceType = {}));
export var TicketInsightsBreakdown;
(function (TicketInsightsBreakdown) {
    // LOCALE = 1,
    TicketInsightsBreakdown[TicketInsightsBreakdown["CHANNEL"] = 2] = "CHANNEL";
    TicketInsightsBreakdown[TicketInsightsBreakdown["COUNTRY"] = 3] = "COUNTRY";
    TicketInsightsBreakdown[TicketInsightsBreakdown["LABELS"] = 4] = "LABELS";
})(TicketInsightsBreakdown || (TicketInsightsBreakdown = {}));
;
export var TicketInsightsSort;
(function (TicketInsightsSort) {
    TicketInsightsSort[TicketInsightsSort["BREAKDOWN_KEY_ASC"] = 1] = "BREAKDOWN_KEY_ASC";
    TicketInsightsSort[TicketInsightsSort["BREAKDOWN_KEY_DESC"] = 2] = "BREAKDOWN_KEY_DESC";
    TicketInsightsSort[TicketInsightsSort["NEW_TICKETS_ASC"] = 3] = "NEW_TICKETS_ASC";
    TicketInsightsSort[TicketInsightsSort["NEW_TICKETS_DESC"] = 4] = "NEW_TICKETS_DESC";
    TicketInsightsSort[TicketInsightsSort["REOPENED_TICKETS_ASC"] = 5] = "REOPENED_TICKETS_ASC";
    TicketInsightsSort[TicketInsightsSort["REOPENED_TICKETS_DESC"] = 6] = "REOPENED_TICKETS_DESC";
    TicketInsightsSort[TicketInsightsSort["CLOSED_TICKETS_ASC"] = 7] = "CLOSED_TICKETS_ASC";
    TicketInsightsSort[TicketInsightsSort["CLOSED_TICKETS_DESC"] = 8] = "CLOSED_TICKETS_DESC";
    TicketInsightsSort[TicketInsightsSort["SOLVED_TICKETS_ASC"] = 9] = "SOLVED_TICKETS_ASC";
    TicketInsightsSort[TicketInsightsSort["SOLVED_TICKETS_DESC"] = 10] = "SOLVED_TICKETS_DESC";
    TicketInsightsSort[TicketInsightsSort["RESPONSE_TIME_ASC"] = 11] = "RESPONSE_TIME_ASC";
    TicketInsightsSort[TicketInsightsSort["RESPONSE_TIME_DESC"] = 12] = "RESPONSE_TIME_DESC";
    TicketInsightsSort[TicketInsightsSort["AGENT_REPLIES_ASC"] = 13] = "AGENT_REPLIES_ASC";
    TicketInsightsSort[TicketInsightsSort["AGENT_REPLIES_DESC"] = 14] = "AGENT_REPLIES_DESC";
    TicketInsightsSort[TicketInsightsSort["CLOSED_BY_MERGE_ASC"] = 15] = "CLOSED_BY_MERGE_ASC";
    TicketInsightsSort[TicketInsightsSort["CLOSED_BY_MERGE_DESC"] = 16] = "CLOSED_BY_MERGE_DESC";
})(TicketInsightsSort || (TicketInsightsSort = {}));
;
//# sourceMappingURL=tickets.js.map